import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Loader, Panel, Progress } from 'rsuite';
import { IpCan } from '../../handlers/ipcan/IpCan';
import { WriteFontProgress } from '../../handlers/pixelArt/pixelArtWS';
import { authHeader } from '../../redux/helpers';
import { axiosService } from '../../redux/services';

type Props = {
    writeFontProgress: WriteFontProgress;
};

type IpCanModuleState = {
    ipcan?: IpCan;
    isLoading: boolean;
};

export const WriteFontNotification = (props: Props) => {
    const [ipcanModule, setIpCanModule] = React.useState<IpCanModuleState>({ isLoading: true });
    const [writeProgress, setWriteProgress] = React.useState<number>(0);
    const intl = useIntl();

    useEffect(() => {
        axiosService
            .getAxios()
            .get(`/ipcanmodules/${props.writeFontProgress.ipcanmoduleId}`, {
                headers: authHeader(),
            })
            .then(ipcanModuleResponse => {
                setIpCanModule({ ipcan: new IpCan(ipcanModuleResponse.data), isLoading: false });
            });
    }, []);

    useEffect(() => {
        if (props.writeFontProgress.writeProgress.totalSize && props.writeFontProgress.writeProgress.size) {
            const total =
                (props.writeFontProgress.writeProgress.size / props.writeFontProgress.writeProgress.totalSize) * 100;

            setWriteProgress(parseFloat(total.toFixed(2)));
        }
    }, [props.writeFontProgress.writeProgress.size]);

    const generateTitle = () => {
        if (ipcanModule.isLoading) {
            return (
                <span>
                    <Loader /> - {props.writeFontProgress.bus + 1} - {props.writeFontProgress.deviceId}`
                </span>
            );
        } else if (ipcanModule.ipcan) {
            return `${ipcanModule.ipcan.getLabel()} (${ipcanModule.ipcan.macStr}) - ${
                props.writeFontProgress.bus + 1
            } - ${props.writeFontProgress.deviceId}`;
        }
    };

    let status: 'active' | 'success' | 'fail' = 'active';

    if (writeProgress === 100) status = 'success';
    if (props.writeFontProgress.writeProgress.err) status = 'fail';

    return (
        <Panel
            header={intl.formatMessage({ id: 'writeFontProgress.writeFont.title' })}
            bordered
            shaded
            className="panel-small">
            {/* <FlexboxGrid align="middle" justify="space-between">
                <FlexboxGrid.Item colspan={20}> */}
            <p className="bold">{generateTitle()}</p>
            {/* </FlexboxGrid.Item>
                <FlexboxGrid.Item>
                    <Button appearance="ghost" size="sm">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </FlexboxGrid.Item>
            </FlexboxGrid> */}

            {props.writeFontProgress.writeProgress.err && (
                <p style={{ color: 'red' }}>{props.writeFontProgress.writeProgress.err}</p>
            )}
            <Progress.Line percent={writeProgress} status={status} />
        </Panel>
    );
};
